import React, { useContext } from 'react'
import { MotorBikesContext } from '../../../../../../contexts/motorBikesContext'
import { ContextService } from '../../../../../../contexts/serviceGralContext'
import SelectInput from '../../../../../../elements/SelectInput'
import { options } from './options'

function ManchadoSelect() {

    const { editNewServiceHandler, newService } = useContext(MotorBikesContext)
    const { currentService, dinamicDataService, editDinamicServiceDataHandler } = useContext(ContextService)


    return (
        <>
            {
                dinamicDataService?.Status != "-1" ?
                    <SelectInput
                        label="Manchado"
                        name="U_Manchado"
                        value={!!newService.U_Manchado ? newService.U_Manchado : ''}
                        inputState={true}
                        functEdit={e => editNewServiceHandler(e)}
                    >
                        <option hidden>Elegir...</option>
                        {options?.YESORNO.map(val => <option key={'manchado' + val}
                            selected={!!newService.U_Manchado && newService.U_Manchado === val}
                            value={val}>{val}</option>)}
                    </SelectInput>
                    :
                    <SelectInput
                        label="Manchado"
                        name="U_Manchado"
                        value={!!currentService.U_Manchado ? currentService.U_Manchado : ''}
                        inputState={true}
                    >
                        <option hidden>Elegir...</option>
                        {options?.YESORNO.map(val => <option key={'manchado' + val}
                            selected={!!currentService.U_Manchado && currentService.U_Manchado === val}
                            value={val}>{val}</option>)}
                    </SelectInput>
            }
        </>
    )
}

export default React.memo(ManchadoSelect)